"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProductContent;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _sharedComponents = require("@site/shared-components");
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("@site/utils");
function ProductContent({
  isMobile,
  product
}) {
  const className = (0, _classnames.default)('d-inline-flex bd-a-1 bd-product px-2 extra-info ms-3', {
    'py-1': isMobile
  });
  return /*#__PURE__*/_react.default.createElement("span", {
    className: className
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "text-muted ms-3"
  }, /*#__PURE__*/_react.default.createElement(_sharedComponents.TooltipWrapper, {
    id: product.Content.Header,
    title: product.Content.SubHeader,
    tooltipContent: /*#__PURE__*/_react.default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: (0, _utils.sanitizeHTML)(product.Content.Messages)
      }
    }),
    tooltipLabelText: product.Content.Header,
    classNames: {
      tooltipWrapper: 'd-flex align-items-center lh-reset'
    },
    stopPropagation: true
  })));
}
ProductContent.propTypes = {
  isMobile: _propTypes.default.bool,
  product: _propTypes.default.shape({
    Content: _propTypes.default.shape({
      Header: _propTypes.default.string.isRequired,
      Messages: _propTypes.default.string.isRequired,
      SubHeader: _propTypes.default.string.isRequired
    })
  })
};